import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';

interface CopierProduct {
  id: string;
  slug: string;
  brand: string;
  title: string;
  type: string;
  image: string;
  features: string[];
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  latestCanon: CopierProduct[] = [];
  latestXerox: CopierProduct[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    forkJoin({
      canon: this.http.get<CopierProduct[]>('assets/data/copier-canon.json'),
      xerox: this.http.get<CopierProduct[]>('assets/data/copier-xerox.json')
    }).subscribe(({ canon, xerox }) => {
      this.latestCanon = canon.slice(-3).reverse();
      this.latestXerox = xerox.slice(-3).reverse();
      this.refreshWowAnimation();
    });
  }

  private refreshWowAnimation(): void {
    setTimeout(() => {
      const wowConstructor = (window as any).WOW;

      if (wowConstructor) {
        new wowConstructor().init();
      }
    });
  }
}
